import { ModalProps, Modal, useToast } from "@introist/react-foundation/v2";
import { useCallback, useState } from "react";
import styled from "styled-components";
import { MicrosoftCapabilitySelector, MicrosoftCapability } from "../../../../modules/connectedaccounts/components/MicrosoftCapabilitySelector";
import { useConnectAccount } from "../../../../modules/connectedaccounts/hooks/use-connect-account";

type Props = ModalProps;

const MinWidthModal = styled(Modal)`
  min-width: 30rem;
`;

export const MicrosoftCapabilityModal = ({ onClose, ...props }: Props) => {
  const toast = useToast();
  const { getMicrosoftAccountConnectUrl } = useConnectAccount();

  // Default to all capabilities selected
  const [selectedCapabilities, setSelectedCapabilities] = useState<MicrosoftCapability[]>([
    "outlook",
    "teams",
    "sharepoint"
  ]);

  const onGenerateLink = useCallback(async () => {
    if (selectedCapabilities.length === 0) {
      toast.error("Please select at least one capability");
      return;
    }

    const url = getMicrosoftAccountConnectUrl(selectedCapabilities);

    try {
      await navigator.clipboard.writeText(url);
      toast.success("Connection link copied to clipboard");
      onClose && onClose();
    } catch (error) {
      toast.error("Failed to copy link to clipboard");
    }
  }, [selectedCapabilities, getMicrosoftAccountConnectUrl, toast, onClose]);

  return (
    <MinWidthModal
      title="Generate Microsoft Account Connection Link"
      primaryButton={{
        title: "Copy Link",
        onClickWithLoading: onGenerateLink,
        disabled: selectedCapabilities.length === 0
      }}
      onClose={onClose}
      {...props}
    >
      <MicrosoftCapabilitySelector
        selectedCapabilities={selectedCapabilities}
        onCapabilitiesChange={setSelectedCapabilities}
      />
    </MinWidthModal>
  );
};
